import TermsModal from '@features/signup/terms/terms';
export default TermsModal;
